import { Box, DialogContent, DialogTitle } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { productBussiness } from "api/bussiness/product/product-bussiness";
import { invalidateProductCatalogCache } from "api/cached";
import { UpdateProduct } from "api/models/request/product/product";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { productFormSchema } from "../schema";

export const EditProduct = observer(() => {
  const queryClient = useQueryClient();
  const {
    productManagement: { openEdit, setProp, productDetail, getProductDetail },
  } = useStores();
  const {
    form: { controls, isValid },
    getControl,
    submitHandler,
  } = useForm<UpdateProduct>(productFormSchema(), {
    code: productDetail?.code || "",
    name: productDetail?.name || "",
    barcode: productDetail?.barcode || "",
    unitOfCalculation: productDetail?.unitOfCalculation || "",
    customerId: productDetail?.customer?.id || "",
    isDisabled: productDetail?.isDisabled || false,
  });
  const saveHandler = useCallback(
    async (data: UpdateProduct) => {
      if (!productDetail?.id) return;
      await productBussiness.update(productDetail?.id, data);
      await invalidateProductCatalogCache(queryClient);
      await getProductDetail(productDetail?.id);
      setProp("openEdit", false);
    },
    [getProductDetail, productDetail?.id, queryClient, setProp],
  );

  useEffect(() => {
    const customerSelection = getControl("customerId");
    customerSelection.setProp("optionItems", [
      {
        label: productDetail?.customer?.dealingName || "",
        value: productDetail?.customer?.id,
      },
    ]);
  }, [
    getControl,
    productDetail?.customer?.dealingName,
    productDetail?.customer?.id,
  ]);

  return (
    <DialogForm
      open={openEdit}
      fullWidth
      maxWidth={"md"}
      onClose={() => setProp("openEdit", false)}
      onCancelBtnClicked={() => setProp("openEdit", false)}
      onSaveBtnClick={async () => {
        await submitHandler(saveHandler);
      }}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Sửa mặt hàng</DialogTitle>
      <DialogContent>
        <Box sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
        </Box>
      </DialogContent>
    </DialogForm>
  );
});

